<div class="area-form__delete">
    <button (click)="deleteArea()"></button>
</div>

<div class="area-form__delete_modal" *ngIf="showDeleteModal === true" [ngClass]="{'in-progress' : inProgress === true}">

    <div class="area-form__delete_modal_bg"></div>
    <div class="area-form__delete_modal_content">

      <div class="title">
        {{'areas.remove' | translate}} "{{area.Nm}}"?
      </div>

      <div class="desc">
        {{'areas.remove-desc' | translate}}
      </div>

        <div class="actions">
            <emq-button styleClass="confirm btn-confirm" (onClick)="confirm()">{{'labels.yes' | translate}}</emq-button>
            <emq-button styleClass="deny btn-deny" (onClick)="deny()">{{'labels.cancel' | translate | titlecase}}</emq-button>
        </div>
    </div>

</div>
